import "./GameCard.style.css";

import { GameCardState } from "../../../utils/states/ConstructorPageStates/GameCardState";

import { IconTools16 } from "../../icons/IconTools/IconTools16";
import { IconGame16 } from "../../icons/IconGame/IconGame16";
import { IconDailyGame16 } from "../../icons/IconDailyGame16";
import { IconHeart16 } from "../../icons/IconHeart/IconHeart16";

interface GameCardProps {
  gameCard: GameCardState;
}

export const GameCard = ({ gameCard }: GameCardProps) => {
  return (
    <div className="game-card">
      <img
        className="game-card__cover"
        src={gameCard.image}
        alt={gameCard.name}
      />
      <span className="game-card__title-container">
        <div className="game-card__title">{gameCard.name}</div>
      </span>
      <div className="game-card__info">
        <div className="game-card__stat">
          <IconTools16 color="#43CDFF" />
          {gameCard.author}
        </div>
        <div className="game-card__stats">
          <div className="game-card__stat">
            <IconGame16 color="#43CDFF" />
            {gameCard.playersAllCount}
          </div>
          <div className="game-card__stat">
            <IconDailyGame16 color="#43CDFF" />
            {gameCard.playersTodayCount}
          </div>
          <div className="game-card__stat">
            <IconHeart16 color="#E4006E" />
            {gameCard.favoriteCount}
          </div>
        </div>
        <div className="game-card__tags-container">
          <div className="game-card__tags">
            {gameCard.tags.slice(0, 3).map((tag, index) => (
              <div className="game-card__tag" key={index}>
                #{tag}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
